import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-quiz-progress-header',
  templateUrl: './quiz-progress-header.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizProgressHeaderComponent {
  readonly percent = input.required<number>();
  readonly stepLabel = input<string>('');
  /** Back is only offered by the frontend-driven engine — the legacy one cannot unwind a chat thread. */
  readonly showBack = input<boolean>(false);
  readonly backDisabled = input<boolean>(false);
  readonly closed = output<void>();
  readonly back = output<void>();

  onCloseClick(): void {
    this.closed.emit();
  }

  onBackClick(): void {
    if (this.backDisabled()) return;
    this.back.emit();
  }

  /** Keyboard activation for the div-as-button back control (Enter/Space). */
  onBackKeydown(event: Event): void {
    event.preventDefault();
    this.onBackClick();
  }

  /** Keyboard activation for the div-as-button close control (Enter/Space). */
  onCloseKeydown(event: Event): void {
    event.preventDefault();
    this.onCloseClick();
  }
}
